import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

export const fadeInUpAnimation = trigger('fadeInUp', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(6px)' }),
    animate('280ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
]);

export const staggerFadeInAnimation = trigger('staggerFadeIn', [
  transition('* => *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(4px)' }),
        stagger(75, [
          animate('260ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
        ]),
      ],
      { optional: true }
    ),
  ]),
]);

export const scaleInAnimation = trigger('scaleIn', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.96)' }),
    animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'scale(1)' })),
  ]),
]);

export const cardRevealAnimation = trigger('cardReveal', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(12px) scale(0.98)' }),
    animate('320ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
  ]),
]);

export const slideInLeftAnimation = trigger('slideInLeft', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateX(-20px)' }),
    animate('320ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
  ]),
]);

/** Popup modal entrance — spring scale + lift. */
export const popupSpringAnimation = trigger('popupSpring', [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.84) translateY(28px)' }),
    animate(
      '460ms cubic-bezier(0.34, 1.45, 0.64, 1)',
      style({ opacity: 1, transform: 'scale(1) translateY(0)' })
    ),
  ]),
]);
